import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import * as _ from 'lodash';


// let loadLGEKUFXScripts = (_url: string) => {
//   let loadScript = (url: string, done: { (): void; (): void; (): void; } | null) => {
//     try {
//       var script = document.createElement('script');
//       script.onload = function () {

//         if (done)
//           done();
//       };
//       script.src = url;
//       document.head.appendChild(script);
//     } catch (error) {
//       console.log(error);
//     }
//     loadScript(_url + "/scripts/xhook/xhook.js", function () { loadScript(_url + "/scripts/tus.js", function () { loadScript(_url + "/scripts/lgekufx.js", null) }) });
//   }
// }
function loadLGEKUFXScripts(url) {
  function loadScript(url, done) {
    try {
      var script = document.createElement('script');
      script.onload = function () {
        if (done)
          done();
      };
      script.src = url;
      document.head.appendChild(script);
    } catch (error) {
      console.log(error);
    }
  }
  loadScript(url + "/scripts/xhook/xhook.js", function () { loadScript(url + "/scripts/tus.js", function () { loadScript(url + "/scripts/lgekufx.js", null) }) });
}
// var Promise = require('promise-polyfill').default;

loadLGEKUFXScripts(environment.LGEKU_FX_SERVER);
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

function loadScript(arg0: string, arg1: () => void) {
  throw new Error('Function not implemented.');
}

